import AnimatedPage from '../components/animatedPage'
import Banner from '../components/banner/banner'

const Layout = ({ title, bg, children }) => {
  return (
    <AnimatedPage>
      <Banner text={title} bg={bg} />
      <div className='flex justify-center w-full p-8 md:p-12'>
        <div className='w-full lg:max-w-7xl'>
          <div className='w-full relative  flex flex-col '>{children}</div>
        </div>
      </div>
    </AnimatedPage>
  )
}

export default Layout
